import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import {Box} from '../../../components/ui/wrapper'
import Button from '../../../components/ui/button'
import {slugify, flatDeep} from '../../../utils/utilFunctions'

const PopularTags = ({boxStyle, tagStyle}) => {
    const BlogTagsQuery = useStaticQuery(graphql `
        query BlogSidebarTagsQuery {
            wpcontent {
            categories(first: 100, where: {exclude: "1"}) {
              edges {
                node {
                  id
                  name
                  slug
                }
              }
            }
          }
        }
    `)
    const tags = BlogTagsQuery.wpcontent.categories.edges;
   

    console.log('this is tags', tags);

    return (
        <Box {...boxStyle}>
            {tags.map((tag, i) => {
                return <Button {...tagStyle} to={`/category/${slugify(tag.node.name)}`} key={slugify(tag.node.name)}>{tag.node.name}</Button>
            })}
        </Box>
    )
}

PopularTags.propTypes = {
    tagStyle: PropTypes.object
}

PopularTags.defaultProps = {
    boxStyle: {
        m: "-5px"
    },
    tagStyle: {
        hover: "2",
        size: 'xsmall',
        skin: "light",
        color: "#ababab",
        bgcolor: "#f5f5f5",
        p: '0 14px',
        m: '5px',
        height: '32px',
        lineheight: '32px',
        fontSize: '13px'
    }   
}

export default PopularTags;